import {DocumentFormProps} from "./DocumentForm";
import {DocumentFormDefault} from "./DocumentFormDefault";
import {DocumentFormReceiver} from "./DocumentFormReceiver";

function DocumentFormCoverLetterEnvelope({
                                             disabled,
                                             value,
                                             onBlur,
                                             validation,
                                             onChange
                                         }: DocumentFormProps) {
    return <>
        <DocumentFormDefault
            disabled={disabled}
            value={value}
            validation={validation}
            onChange={onChange}
            onBlur={onBlur}
        />
        <DocumentFormReceiver
            disabled={disabled}
            value={value}
            validation={validation}
            onChange={onChange}
            onBlur={onBlur}
        />
    </>
}

export {
    DocumentFormCoverLetterEnvelope
}
